
$(document).ready(function () {
  $(".quantity__button").on("click", function (event) {
    event.preventDefault(); // Prevent default behavior
    
    // Ensure the click is on a valid target within a correct context
    var button = $(event.currentTarget); // Get the clicked button
    var quantityWrapper = button.closest('.quantity-wrapper'); // Find the closest quantity wrapper

    if (!quantityWrapper) {
      return; // If no quantity wrapper is found, return early
    }

    // Get the quantity input within this specific wrapper
    var quantityInput = quantityWrapper.find('.quantity-input');

    if (!quantityInput) {
      return; // If there's no quantity input, exit early
    }

    var currentQty = parseInt(quantityInput.val(), 10); // Get current quantity
    var newQty = currentQty; // Start with the current quantity
    
    // Determine if the clicked button is "plus" or "minus"
    if (button.hasClass('plus')) {
      newQty = currentQty + 1; // Increment by 1
    } else if (button.hasClass('minus') && currentQty > 1) {
      newQty = currentQty - 1; // Decrement by 1, but not below 1
    }

    // Ensure the new quantity doesn't fall below 1
    if (newQty < 1) {
      newQty = 1;
    }

    // Update the quantity input with the new value
    quantityInput.val(newQty.toString());

    // Enable/disable the minus button based on the new quantity
    var minusButton = quantityWrapper.find('.quantity__button.minus');
    if (newQty == 1) {
      minusButton.attr("disabled", "disabled");
    } else {
      minusButton.removeAttr("disabled");
    }
  });
});


(function () {
  function triggerKlaviyoPopup() {
    // Ensure Klaviyo is ready before opening the form
    window._klOnsite = window._klOnsite || [];
    console.log('[Klaviyo Trigger] okendo_quiz_response_id detected — opening form Upszcu');

    setTimeout(() => {
      window._klOnsite.push(['openForm', 'Upszcu']);
    }, 1000);
  }

  function checkForQuizParam() {
    if (window.location.href.includes('okendo_quiz_response_id=')) {
      triggerKlaviyoPopup();
    }
  }

  // Run once on load
  checkForQuizParam();

  // Detect future URL changes (Okendo uses history.pushState)
  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    setTimeout(checkForQuizParam, 500);
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    setTimeout(checkForQuizParam, 500);
  };

  // Also listen for popstate (back/forward navigation)
  window.addEventListener('popstate', checkForQuizParam);
})();
